export default __webpack_public_path__ + "static/media/bauhaus-lg.fd377820.svg";